import { render, staticRenderFns } from "./customersavingrate.vue?vue&type=template&id=34555bfe&scoped=true"
import script from "./customersavingrate.vue?vue&type=script&lang=js"
export * from "./customersavingrate.vue?vue&type=script&lang=js"
import style0 from "./customersavingrate.vue?vue&type=style&index=0&id=34555bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34555bfe",
  null
  
)

export default component.exports